<template>
  <div class="Fragments h-100">
    <ItemTable
      :fields="fields"
      :league="this.$parent.league"
      :getHref="this.getHref"
      category="fragment"
      :smallScreen="smallScreen"
    ></ItemTable>
  </div>
</template>

<script>
// @ is an alias to /src
import ItemTable from "../components/Simple-ItemTable";
import isMobile from "../mixins/mobileCheck";
export default {
  name: "Fragments",
  components: { ItemTable },
  mixins: [isMobile],
  props: ["smallScreen"],
  data() {
    return {
      fields: [
        {
          key: "icon",
          sortable: false,
          thStyle: "width: 3em;",
        },
        {
          key: "name",
          sortable: false,
        },
        {
          key: "change",
          thClass: "text-right",
          tdClass: "text-nowrap, text-right",
        },
        {
          key: "divine",
          sortable: true,
          tdClass: "text-right",
          thClass: "text-right",
        },
        {
          key: "mean",
          sortable: true,
          tdClass: "text-right",
          thClass: "text-right",
        },
      ],
    };
  },
  mounted() {},
  methods: {
    getHref(item) {
      if (item != undefined) {
        return `https://www.pathofexile.com/trade/search/${this.$parent.league}?q={"query":{"status":{"option":"online"},"type":"${item.name}","stats":[{"type":"and","filters":[]}]},"sort":{"price":"asc"}}`;
      }
    },
  },
};
</script>

<style lang="scss"></style>
